import { API_SERVER } from '@/shared/api/config'
import formatDate from '@/shared/utils/format-date'
import RSA256 from '@/shared/utils/RSA256'
import router from '@/shared/router'
import axios from 'axios'
import Vue from 'vue'

let show = true

// 请求拦截器
axios.interceptors.request.use(req => {
  if (sessionStorage.getItem('token') && !req.headers.Authorization) {
    req.headers.Authorization = sessionStorage.getItem('token')
  }
  show = true
  req.data = {
    charset: 'utf-8',
    biz_content: '',
    method: '',
    format: 'json',
    sign: '',
    app_id: process.env.NODE_ENV === 'production' ? '20191011632233178303561728' : '20191011632233178303561728',
    sign_type: 'RSA2',
    version: '1.0',
    timestamp: ''
  }
  req.data.method = req.url.method
  delete req.url.method
  req.data.biz_content = JSON.stringify(req.url)
  req.url = API_SERVER.default
  const date = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
  req.data.timestamp = date
  req.data.sign = RSA256(req.data.biz_content, req.data.method, req.data.timestamp)
  return req
}, err => {
  return Promise.reject(err)
})

// 响应拦截器
axios.interceptors.response.use(res => {
  if (JSON.parse(res.config.data).method) {
    const methodName = `${JSON.parse(res.config.data).method.replace(/\./g, '_')}_response`
    if (res.data[methodName].code === '10000') {
      return res
    } else {
      if (res.data[methodName].sub_code === '-100') {
        sessionStorage.clear()
        router.push({ name: 'AUTH' })
        if (show) {
          if (res.data[methodName].sub_msg) {
            Vue.prototype.$message.error(res.data[methodName].sub_msg)
          } else {
            Vue.prototype.$message.error(res.data[methodName].msg)
          }
          show = false
        }
      } else {
        if (res.data[methodName].sub_msg) {
          Vue.prototype.$message.error(res.data[methodName].sub_msg)
        } else {
          Vue.prototype.$message.error(res.data[methodName].msg)
        }
      }
      return res
    }
  } else {
    if (res.data.error_response.sub_msg) {
      Vue.prototype.$message.error(res.data.error_response.sub_msg)
    } else {
      Vue.prototype.$message.error(res.data.error_response.msg)
    }
  }
}, err => {
  if (err.response) {
    if (err.response.status === 401) {
      sessionStorage.clear()
      router.push({ name: 'AUTH' })
      if (show) {
        Vue.prototype.$message.error(err.response.data.message)
        show = false
      }
    } else {
      if (err.response.data.message) {
        Vue.prototype.$message.error(err.response.data.message)
      } else {
        Vue.prototype.$message.error('接口调用出错')
      }
    }
  }
  return Promise.reject(err)
})

export default axios
